module.exports = __webpack_public_path__ + "static/media/wwin_logo_black.2927b8b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wwin_logo_black.png
// module id = 552
// module chunks = 0